import { render, staticRenderFns } from "./GFSettlementDashboard.vue?vue&type=template&id=930b8090"
import script from "./GFSettlementDashboard.vue?vue&type=script&lang=js"
export * from "./GFSettlementDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports